"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var root_1 = require("./styled/root");

var Grid = function Grid(_a) {
  var className = _a.className,
      testID = _a["data-testid"],
      children = _a.children,
      rest = tslib_1.__rest(_a, ["className", 'data-testid', "children"]);

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: className,
    "data-testid": testID
  }, rest), children);
};

exports.Grid = Grid;